import type { QueryClient } from '@tanstack/react-query';
import { invalidateEpisodeCollectionQueries } from '../episodeCollectionQueries';
import {
  ALL_SUBTASKS_KEY,
  DATASET_EPISODES_KEY,
  LABEL_STATS_KEY,
  SEGMENT_LABELS_KEY,
  aiPendingSegmentsKey,
  cloudEpisodeKey,
  episodeSegmentsKey,
  episodeTrimKey,
} from './keys';

export function invalidateTrimQueries(
  queryClient: QueryClient,
  episodeId: string,
) {
  void queryClient.invalidateQueries({ queryKey: episodeTrimKey(episodeId) });
  void queryClient.invalidateQueries({
    queryKey: ['episodeReviewStatus', episodeId],
  });
  void queryClient.invalidateQueries({ queryKey: ['episodeLocks', episodeId] });
}

export function invalidateSegmentQueries(
  queryClient: QueryClient,
  episodeId: string,
) {
  void queryClient.invalidateQueries({ queryKey: episodeSegmentsKey(episodeId) });
  void queryClient.invalidateQueries({
    queryKey: aiPendingSegmentsKey(episodeId),
  });
  void queryClient.invalidateQueries({ queryKey: cloudEpisodeKey(episodeId) });
  void invalidateEpisodeCollectionQueries(queryClient);
  void queryClient.invalidateQueries({ queryKey: DATASET_EPISODES_KEY });
  void queryClient.invalidateQueries({ queryKey: ALL_SUBTASKS_KEY });
  void queryClient.invalidateQueries({
    queryKey: ['episodeReviewStatus', episodeId],
  });
  void queryClient.invalidateQueries({ queryKey: ['episodeLocks', episodeId] });
}

export function invalidateLabelQueries(queryClient: QueryClient) {
  void queryClient.invalidateQueries({ queryKey: SEGMENT_LABELS_KEY });
  void queryClient.invalidateQueries({ queryKey: LABEL_STATS_KEY });
}

export function invalidateAllSegmentLists(queryClient: QueryClient) {
  void queryClient.invalidateQueries({ queryKey: episodeSegmentsKey() });
  void queryClient.invalidateQueries({ queryKey: ALL_SUBTASKS_KEY });
}
